import React, { memo, useRef } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Icon, IconPlus } from '@redlink/components/atoms';
import { TextInput } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';

export const LinkTemplateListItem = memo(
  ({ item, onAdd, onChange, onRemove }) => {
    const { styles, colors } = useStyle();
    const inputRef = useRef(null);
    const { dictionary } = useLocale();

    const {
      logoName,
      title,
      prefix,
      withPostfix,
      value = {},
      isNewItem = false,
    } = item;
    const { raw } = value;

    const normalizedTitle = dictionary.shopContact[title] ?? title;

    return (
      <View style={styles.container}>
        <View style={styles.iconContainer}>
          <Icon name={logoName} size={24} color={colors.gray23} />
        </View>
        <TextInput
          ref={inputRef}
          prefix={withPostfix ? '@' : ''}
          en
          title={withPostfix ? `${normalizedTitle} Username` : normalizedTitle}
          value={raw}
          onChangeText={(value) => {
            onChange({
              ...item,
              value: {
                title,
                logoName,
                raw: value,
                url: `${prefix}${value}`,
              },
            });
          }}
          style={styles.textInput}
          withClearButton={isNewItem}
          onClearButtonPress={onRemove}
          withActionButton={!isNewItem}
          actionButtonIcon={<IconPlus size={15} color={colors.white} />}
          actionButtonVariant="actionBlueIcon"
          onActionButtonPress={() => {
            onAdd(
              {
                ...item,
                value: {
                  ...item.value,
                  raw: '',
                },
              },
              {
                ...item,
                isNewItem: true,
                value: {
                  raw,
                  title,
                  logoName,
                  url: `${prefix}${raw}`,
                },
              }
            );
          }}
        />
      </View>
    );
  }
);

const useStyle = createUseStyle(({ ltrFlexDirection }) => ({
  container: {
    flex: 1,
    flexDirection: ltrFlexDirection,
    alignItems: 'center',
  },
  iconContainer: {
    width: 50,
    alignItems: 'center',
  },
  textInput: {
    flex: 1,
  },
}));
